// A calibration sheet: every slot of the configured sheet drawn as a thin
// outline with its sticker number and a centre cross. Printed on plain paper
// (or held against a label sheet) it shows whether scaling, browser margins
// and the device offsets put each label exactly on its sticker.

import {
  computeSheetMetrics,
  normalizeDeviceCalibration,
  normalizeSheetGeometry,
} from "./sheetLayout";

export const buildAlignmentTestDocument = ({ geometry, calibration, autoPrint = true }) => {
  const sheet = normalizeSheetGeometry(geometry);
  const offsets = normalizeDeviceCalibration(calibration);
  const metrics = computeSheetMetrics(sheet);
  const slots = Array.from(
    { length: metrics.slotsPerPage },
    (_entry, index) => `<div class="slot"><span>${index + 1}</span></div>`
  ).join("");

  return `<!doctype html>
<html>
<head>
  <meta charset="utf-8" />
  <title>Label sheet alignment test</title>
  <style>
    * { box-sizing: border-box; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    @page { size: ${metrics.paper.widthMM}mm ${metrics.paper.heightMM}mm; margin: 0; }
    html, body { margin: 0; padding: 0; width: ${metrics.paper.widthMM}mm; background: #fff; font-family: "Helvetica Neue", Arial, sans-serif; }
    .page {
      position: relative;
      width: ${metrics.paper.widthMM}mm;
      height: ${metrics.paper.heightMM}mm;
      padding: ${sheet.marginTopMM + offsets.printOffsetYMM}mm 0 0 ${sheet.marginLeftMM + offsets.printOffsetXMM}mm;
      display: grid;
      grid-template-columns: repeat(${sheet.columns}, ${metrics.labelWidthMM}mm);
      grid-template-rows: repeat(${sheet.rows}, ${metrics.labelHeightMM}mm);
      column-gap: ${sheet.labelColumnGapMM}mm;
      row-gap: ${sheet.labelRowGapMM}mm;
      align-content: start;
      justify-content: start;
      overflow: hidden;
    }
    .page::before { content: "100 mm"; position: absolute; left: 10mm; top: 8mm; width: 100mm; border-top: 0.25mm solid #111; font: 7pt Arial; padding-top: 1mm; }
    .slot {
      position: relative;
      border: 0.25mm solid #111;
      border-radius: 2.2mm;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .slot::before, .slot::after { content: ""; position: absolute; background: #111; }
    .slot::before { width: 6mm; height: 0.2mm; }
    .slot::after { width: 0.2mm; height: 6mm; }
    .slot span { position: absolute; top: 1.2mm; left: 1.6mm; font: 700 9pt/1 "Helvetica Neue", Arial, sans-serif; }
  </style>
</head>
<body>
  <section class="page">${slots}</section>${
    autoPrint
      ? `
  <script>
    (function () {
      function go() { setTimeout(function () { window.print(); }, 80); }
      if (document.readyState === "complete" || document.readyState === "interactive") go();
      else document.addEventListener("DOMContentLoaded", go);
    })();
  </script>`
      : ""
  }
</body>
</html>`;
};
